import { render } from "./conversation.vue?vue&type=template&id=583431e2"
import script from "./conversation.js?vue&type=script&lang=js&external"
export * from "./conversation.js?vue&type=script&lang=js&external"

import "./conversation.vue?vue&type=style&index=0&id=583431e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__